import React, { useEffect, useState } from 'react'
import './OperatProf.css'
import Form from 'react-bootstrap/Form';
import dummyImage from '../../assets/dummyImage.jpeg'
import ReactStars from "react-rating-stars-component";
import { FaRegThumbsDown, FaRegThumbsUp } from "react-icons/fa6";
import { SERVER_URL } from '../../../ServerUrl';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux/es/exports";
import Swal from 'sweetalert2';



const AllReviews = ({ operatorAllReviews, onFeedbackSuccess }) => {
    const [feedbackData, setFeedbackData] = useState({ punctuality: 4 });
    const loggedUser = useSelector((state) => state?.userReducer?.userdataOperator?.user?._id);
    const [userId, setUserId] = useState(null)
    const [helpfulFeedback, setHelpfulFeedback] = useState({
        yesCount: 0,
        noCount: 0,
        userVote: null
    });

    useEffect(() => {
        setUserId(loggedUser)
    }, [loggedUser])

    const handleHelpfulVote = async (reviewId, isHelpful) => {
        try {
            const response = await axios.post(
                `${SERVER_URL}/review/${reviewId}/helpful/${userId}`,
                { isHelpful }
            );

            setHelpfulFeedback({
                yesCount: response.data.data.yesCount,
                noCount: response.data.data.noCount,
                userVote: isHelpful ? 'yes' : 'no'
            });

            showSuccessAlert();

            // Call parent callback
            if (onFeedbackSuccess) {
                onFeedbackSuccess(reviewId, response.data.data);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to submit feedback');
            console.error('Feedback submission error:', error);
        }
    };





    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    };

    // Add formattedReviewDate to each item in operatorAllReviews
    const reviewsWithFormattedDates = operatorAllReviews?.map((item) => ({
        ...item,
        formattedReviewDate: formatDate(item.createdAt),
    }));
    console.log(operatorAllReviews, "operatorAllReviews")



    const showSuccessAlert = () => {
        Swal.fire({
            title: 'Thank you!',
            text: 'Your feedback has been submitted successfully',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
            willClose: () => {
                // Optional: Any cleanup after closing
            }
        });
    };


    const shouldShowVotingSection = (review) => {
        // Don't show if userId is null (user not logged in)
        if (!userId) return false;

        // Check if user has already voted
        return !review.helpfulFeedback?.feedbackUsers?.some(
            feedback => feedback.userId.toString() === userId.toString()
        );
    };

    const shouldShowHelpfulCounts = (review) => {
        const yesCount = review.helpfulFeedback?.yesCount || 0;
        const noCount = review.helpfulFeedback?.noCount || 0;
        return yesCount > 0 || noCount > 0;
    };


    return (
        <div>
            <div className='reviewSearchMain'>
                <input type="text" className='searchCustormerReview' placeholder='Search customer reviews' />
                <button className='searcBtn'>Search</button>
            </div>
            <div className='reviewSearchMain' style={{ marginTop: "10px" }}>
                <div className='searchBytText'>SORT BY</div>
                <div className='searchBytText'>FILTER BY</div>
            </div>
            <div className='reviewSearchSelects' style={{ marginTop: "10px" }}>
                <Form.Select aria-label="Default select example" className='reviewsSelect'>
                    <option>Top reviews</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </Form.Select>
                <Form.Select aria-label="Default select example" className='reviewsSelect'>
                    <option>All reviewers</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </Form.Select>
                <Form.Select aria-label="Default select example" className='reviewsSelect'>
                    <option>All stars</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </Form.Select>
                <Form.Select aria-label="Default select example" className='reviewsSelect'>
                    <option>All texts,images and videos</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </Form.Select>
            </div>
            <div className='ratingreviewText'>Ratings & Reviews</div>
            {/* <button className='tenslateTetBtn'>Translate all reviews to English</button> */}
            {reviewsWithFormattedDates?.map((item) => (
                <div className="reviewMapOuter" key={item.bookingId}> {/* Add a unique key */}
                    <div className='rewUserImgSection'>
                        <img src={dummyImage} className='dummyImageReviwe' alt="" />
                        <div className='userReName'>{item?.bookingId?.passengerDetails[0]?.firstName}</div>
                    </div>
                    <div className="starTitlSectio">
                        <ReactStars
                            count={5}
                            value={item?.avgg}
                            size={24}
                            activeColor="#ffd438"
                            isHalf={true}
                            precision={0.1}
                            edit={false}
                            className="starsColor"
                        />
                        <div className="Reviewtit">{item?.reviewTitle}</div>
                    </div>
                    <div className="userReName">Reviewed on {item?.formattedReviewDate}</div>
                    <div className="userReName">{item?.reviewDescription}</div>
                    <div className='ownerrespText'>Response from the owner <span style={{ fontWeight: "400" }}>({item?.owenerResponsedate})</span> </div>
                    <div className='ownerresp'>{item?.owenerRespons}</div>
                    {shouldShowHelpfulCounts(item) && (
                        <div className='helpful-counts'>
                            {item.helpfulFeedback?.yesCount > 0 && (
                                <div className='ownerresp'>
                                    {item.helpfulFeedback.yesCount} {item.helpfulFeedback.yesCount === 1 ? 'person' : 'people'} found this helpful
                                </div>
                            )}
                            {item.helpfulFeedback?.noCount > 0 && (
                                <div className='ownerresp'>
                                    {item.helpfulFeedback.noCount} {item.helpfulFeedback.noCount === 1 ? 'person' : 'people'} found this not helpful
                                </div>
                            )}
                        </div>
                    )}

                    {shouldShowVotingSection(item) && (
                        <div className='reviewHelpFullSection'>Was this review helpfull? <span className='thumbSec'><FaRegThumbsUp className='reviewThumb'
                            onClick={() => handleHelpfulVote(item._id, true)}
                        />YES</span> | <span className='thumbSec'><FaRegThumbsDown className='reviewThumb'
                            onClick={() => handleHelpfulVote(item._id, false)}
                        />NO</span> </div>
                    )}
                </div>
            ))}

        </div>
    )
}

export default AllReviews
